<template>
  <v-navigation-drawer
    id="navigation"
    v-resize="onResize"
    app
    color="navbar"
    :temporary="isTemp"
    :value="isShown"
    @input="toggle"
  >
    <header class="nav-header">
      <div class="logo">
        <img src="@/assets/logo.png" alt="Match Center" />
      </div>
      <p class="title">Match Center Scoring</p>
      <p class="name">{{ userName }}</p>
      <p class="email">Nin: {{ nin }}</p>
    </header>
    <v-list>
      <v-list-item
        v-for="(link, i) in pages"
        :key="i"
        color="white"
        :to="link.to"
      >
        <v-list-item-icon>
          <v-icon>{{ link.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ link.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-dialog
        v-model="showSettings"
        fullscreen
        transition="dialog-bottom-transition"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-list-item v-bind="attrs" v-on="on">
            <v-list-item-icon>
              <v-icon>{{ settingsIcon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Settings</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closeSettings">
              <v-icon>{{ closeIcon }}</v-icon>
            </v-btn>
            <v-toolbar-title>Settings</v-toolbar-title>
          </v-toolbar>

          <v-card-text class="pa-5">
            <settings-form />
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mdiHome, mdiTrophy, mdiCog, mdiClose } from "@mdi/js";
import SettingsForm from "@/components/SettingsForm/index.vue";

export default {
  name: "NavDrawer",
  components: {
    SettingsForm,
  },
  data() {
    return {
      isMobile: null,
      showSettings: false,
      settingsIcon: mdiCog,
      closeIcon: mdiClose,
      pages: [
        {
          title: "Home",
          icon: mdiHome,
          to: { name: "app-landing" },
        },
        {
          title: "My Scored Matches",
          icon: mdiHome,
          to: { name: "app-marker-matches" },
        },
        {
          title: "Find a Match",
          icon: mdiTrophy,
          to: { name: "app-marker-match-finder" },
        },
      ],
    };
  },
  computed: {
    userName() {
      return this.$store.getters["auth/name"];
    },
    nin() {
      return this.$store.getters["auth/nin"];
    },
    isTemp() {
      return this.isMobile;
    },
    isShown() {
      if (!this.isMobile) {
        return true;
      } else {
        return this.$store.getters["components/isNavVisible"];
      }
    },
  },
  created() {
    this.isMobile = this.$vuetify.breakpoint.mobile;
  },
  methods: {
    toggle(evt) {
      if (evt === false) {
        this.$store.commit("components/toggleNav");
      }
    },

    closeSettings() {
      this.showSettings = false;
    },

    onResize() {
      const isMobile = this.$vuetify.breakpoint.mobile;
      if (this.isMobile !== isMobile) {
        this.isMobile = isMobile;
        this.$store.commit("components/toggleNav", false);
      }
    },
  },
};
</script>

<style scoped lang="scss">
#navigation {
  padding: var(--set) 0 var(--seb) var(--sel) !important;
  header.nav-header {
    text-align: center;
    background-color: var(--nav-color);
    flex-grow: 0;
    padding: 20px 0 20px 0;
    border-bottom: 1px solid #fff;

    .logo {
      display: inline-block;
      margin: 0 auto;
    }

    .title {
      font-weight: bold;
      color: #ffffff;
      text-transform: uppercase;
      font-size: 24px;
    }

    .name,
    .email {
      text-align: left;
      color: #fff;
      font-size: 16px;
      padding-left: 20px;
      margin: 0;
      font-weight: bold;
    }

    .email {
      font-weight: normal;
      margin-top: 0;
      font-style: italic;
    }
  }
}
</style>
